import { STRENGTH } from './messages';

const requireValidation = (fields, key, criteria) => {
  const field = fields[key];
  const message = criteria.message || STRENGTH;
  return !field.match(criteria.value) ? message : null;
};
export default requireValidation;
